<template>
    <div id="pad-wrapper" class="animation-duration">
        <div class="row head">
            <div class="col-md-9">
                <h4>Код для установки на сайт</h4>
            </div>
            <div class="col-md-3">

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <p>Вставьте код на Ваш сайт перед закрытием тега  <strong>body</strong></p>
            </div>
            <div class="col-md-12">
                <div v-html="text" class="mycode">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                text: '&lt;script type="text/javascript" src="https://pxl.knam.pro/code/code.php" charset="UTF-8">&lt;/script>'
            }
        }
    }
</script>

<style scoped>
.mycode {
    background: #eee;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #aaa;
}
</style>